import styled from "styled-components";
import {AccountCategoryStyle, TabStyle} from "./AccountDropdown";
import {
    accountsTypes,
    accountsTypesHM,
    backgroundColorAccounts,
    fontColorAccounts
} from "../../../../../../../utils/const/usersTypes";
import {useQuery} from "react-query";
import apiService from "../../../../../../../api/apiService";
import {userDataFromSf} from "../../../../../../../utils/const/query-key";
import {accountsCountries} from "../../../../../../../utils/const/accountCountries";

const AccountsListStyle = styled.div`
  width: 500px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  position: absolute;
  z-index: 1;
  margin-top: -8px;
  margin-left: -1px;
  overflow: auto;
  height: 350px;

  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 4px;
    background: #EFEFEF;
  }

  &::-webkit-scrollbar-thumb {
    background: #838383;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #777676;
  }
`;

const AccountRow = styled.li`
  border-bottom: solid 1px #E5E5E5;
  padding: 12px;
  list-style: none;
  display: grid;
  grid-template-columns: auto auto;
  cursor: pointer;
`;

const ListOfAccountUl = styled.ul`
  padding-left: 0px;
  margin-top: 0px;

  .empty_accounts {
    margin-top: 150px;
    color: #bdb5b5;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  padding-left: 15px;
  text-align: left;
  flex-direction: column;
  justify-content: center;

  .accountNameAndId {
    color: #202020;
    font: normal normal normal 14px/20px DIN Pro;
  }
  
  .accountCountry{
    color:rgb(155 153 153);
  }
`;
const RightColumn = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 15px;
`;

const AccountsList = (props) => {
    const {category, setHide, accounts} = props;
    const {data: userDataSF} = useQuery(userDataFromSf, () =>
        apiService.getUserDataSF()
    );


    const sortList = () => {
        let listWithTheSameCountry;
        let listWithoutTheSameCountry;
        if(userDataSF.length > 0){
             listWithTheSameCountry = accounts?.filter((account) => {
                return userDataSF[0].country?.toLowerCase() === accountsCountries.get(account.countryCode)?.toLowerCase()
            })
             listWithoutTheSameCountry = accounts?.filter((account) => {
                return userDataSF[0].country?.toLowerCase() !== accountsCountries.get(account.countryCode)?.toLowerCase()
            });
        }
        else{
            listWithoutTheSameCountry = accounts;
        }

        listWithoutTheSameCountry.sort(((a, b) => {
            let fa = accountsCountries.get(a.countryCode)?.toLowerCase(),
                fb = accountsCountries.get(b.countryCode)?.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        }))
        const sortedList = listWithTheSameCountry ?   listWithTheSameCountry.concat(listWithoutTheSameCountry) : listWithoutTheSameCountry;
        return sortedList;
    }

    return (
        <AccountsListStyle>
            <ListOfAccountUl>
                {accounts.length === 0 ?<div className={"empty_accounts"}>No Options</div> :sortList().map((account) => {
                    return (
                        <AccountRow id={"account_row"}
                                    onClick={() => setHide(account.name, account.sfCustomerId,account.recordType.recordTypeName,account.recordType.id,
                                        <AccountCategoryStyle
                                            color={fontColorAccounts.get(account.recordType.recordTypeName)}
                                            background={backgroundColorAccounts.get(account.recordType.recordTypeName)}>
                                            {accountsTypesHM.get(account.recordType.recordTypeName)}
                                        </AccountCategoryStyle>)} key={account.sfCustomerId}>
                            <LeftColumn>
                                <div className={"accountNameAndId"}>
                                    {account.name}
                                    (#{account.sfCustomerId})
                                </div>
                                <div className={"accountCountry"}>
                                    {accountsCountries.get(account.countryCode)}
                                </div>
                            </LeftColumn>
                            <RightColumn>
                                <AccountCategoryStyle color={fontColorAccounts.get(account.recordType.recordTypeName)}
                                                      background={backgroundColorAccounts.get(account.recordType.recordTypeName)}>
                                    {accountsTypesHM.get(account.recordType.recordTypeName)}
                                </AccountCategoryStyle>
                            </RightColumn>
                        </AccountRow>
                    )
                })}


            </ListOfAccountUl>
        </AccountsListStyle>
    );

}
export default AccountsList;
